<template>
  <div>
    <applicant-message-sent-date
      :date="date"
      :is-read="isRead"
    />
    <applicant-message-subject :subject="subject" />
    <applicant-message-body :body="body" />
  </div>
</template>

<script>
import ApplicantMessageSentDate from '@/components/atoms/ApplicantMessageSentDate.vue'
import ApplicantMessageSubject from '@/components/atoms/ApplicantMessageSubject.vue'
import ApplicantMessageBody from '@/components/atoms/ApplicantMessageBody.vue'

export default {
  components: {
    ApplicantMessageSentDate,
    ApplicantMessageSubject,
    ApplicantMessageBody
  },
  props: {
    date: {
      type: String,
      default: ''
    },
    isRead: {
      type: Boolean,
      default: null
    },
    subject: {
      type: String,
      default: ''
    },
    body: {
      type: String,
      default: ''
    }
  }
}
</script>
